import request from '../httpClient';

export const getListRoles = (scope: string) => request.get('/roles', {scope});



// WEBPACK FOOTER //
// ./src/services/api/roleApi.ts